import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { FlowBehaviours } from '../../components/Form/Constants';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import Utils from '../../utils';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '..';
import FormId from '../../components/Form/FormId';
import Logger from '../../lib/analytics/logger';
import NotificationContext from '../../context/NotificationContext';
import rewardCenterMiddleware from '../RewardCenter/utils/middleware';
var KycConstants = require('../../utils/kyc/Constants');
var CombinedForm = require('../../assets/star/forms/combined.form');
var STEPS = {
  personalDetails: 0,
  additionalDocuments: 1,
  accountDetails: 2
};
var ALERT_TYPES = {
  error: 'error',
  warning: 'warning',
  success: 'success'
};
var ALERT_TITLES = {
  kycSuccess: getText(TEXT_KEY.ALERT_KYC_SUCCESS),
  kycError: getText(TEXT_KEY.ALERT_KYC_ERROR),
  deDupeError: getText(TEXT_KEY.ALERT_DUP_ERROR)
};
var DOCUMENT_TYPES = {
  DRIVER_LICENCE: 'dl',
  PASSPORT: 'pp'
};
var UpgradeAccountFlow = /*#__PURE__*/function (_Component) {
  function UpgradeAccountFlow() {
    var _this;
    _classCallCheck(this, UpgradeAccountFlow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UpgradeAccountFlow, [].concat(args));
    _this.state = {
      alertType: '',
      alertTitle: '',
      serverResponse: '',
      layout: CombinedForm,
      inputBehaviour: {},
      userStatus: 'unverified',
      isLoading: false,
      navTo: QueryParamsProxy.findParam(RouteParamConstants.PARAM_NAVIGATE_TO, null),
      step: STEPS.personalDetails
    };
    _this._handleStepChange = function () {
      var setFormInfo = _this.props.setFormInfo;
      var step = _this.state.step;
      if (step === STEPS.personalDetails) {
        setFormInfo({
          key: FormId.COUNTRY,
          value: 'AU',
          validated: true
        });
        Logger.sendEvent(EVENT_TYPES.KYC_BASIC_CHECK_INIT);
      } else if (step === STEPS.additionalDocuments) {
        setFormInfo({
          key: FormId.DOCUMENT_TYPE,
          value: 'dl',
          validated: true
        });
        setFormInfo({
          key: FormId.STATE,
          value: 'dl_nsw',
          validated: true
        });
        Logger.sendEvent(EVENT_TYPES.KYC_DOCUMENT_CHECK_INIT);
      }
    };
    _this.layoutChangeHandler = function (changeType, newValue) {
      var newLayout = _objectSpread({}, _this.state.layout);
      var personalDetailsStep = STEPS.personalDetails;
      var additionalDocumentStep = STEPS.additionalDocuments;
      var personalDetailsStepLength = 12;
      switch (changeType) {
        case 'toggleAutocomplete':
          newLayout.steps[personalDetailsStep].formInputList[10].options = KycConstants.AUSTRALIAN_STATES;
          newLayout.steps[personalDetailsStep].formInputList[5].hasAutocompleteToggle = true;
          if (!newLayout.steps[personalDetailsStep].formInputList[11].hide) {
            newLayout.steps[personalDetailsStep].formInputList[10].hide = false;
          }
          for (var i = 4; i <= personalDetailsStepLength; i++) {
            newLayout.steps[personalDetailsStep].formInputList[i].hide = !newLayout.steps[personalDetailsStep].formInputList[i].hide;
          }
          newLayout.steps[personalDetailsStep].formInputList[11].hide = true;
          break;
        case 'autocompleteOff':
          newLayout.steps[personalDetailsStep].formInputList[5].hasAutocompleteToggle = false;
          newLayout.steps[personalDetailsStep].formInputList[4].hide = true;
          for (var _i = 5; _i <= personalDetailsStepLength; _i++) {
            newLayout.steps[personalDetailsStep].formInputList[_i].hide = false;
          }
          newLayout.steps[personalDetailsStep].formInputList[10].hide = true;
          newLayout.steps[personalDetailsStep].formInputList[11].hide = false;
          break;
        case 'autocompleteOff_NZ':
          newLayout.steps[personalDetailsStep].formInputList[10].options = KycConstants.NEW_ZEALAND_REGIONS;
          newLayout.steps[personalDetailsStep].formInputList[5].hasAutocompleteToggle = false;
          newLayout.steps[personalDetailsStep].formInputList[4].hide = true;
          for (var _i2 = 5; _i2 <= personalDetailsStepLength; _i2++) {
            newLayout.steps[personalDetailsStep].formInputList[_i2].hide = false;
          }
          newLayout.steps[personalDetailsStep].formInputList[11].hide = true;
          break;
        case 'toggleDocumentStateCountry':
          if (newValue === DOCUMENT_TYPES.DRIVER_LICENCE) {
            newLayout.steps[additionalDocumentStep].formInputList[5].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[6].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[7].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[8].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[9].hide = false;
          } else if (newValue === DOCUMENT_TYPES.PASSPORT) {
            newLayout.steps[additionalDocumentStep].formInputList[5].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[6].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[7].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[8].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[9].hide = true;
          }
          break;
      }
      _this.setState({
        layout: newLayout
      });
    };
    _this.handleCountryChange = function () {
      var value = _this.props.formInfo.country.value;
      if (value === 'AU') {
        _this.layoutChangeHandler('toggleAutocomplete');
      } else if (value === 'NZ') {
        _this.layoutChangeHandler('autocompleteOff_NZ');
      } else {
        _this.layoutChangeHandler('autocompleteOff');
      }
    };
    _this.submitHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var deDupePass, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.setState({
              isLoading: true
            });
            _context.next = 3;
            return _this.deDupeCheck();
          case 3:
            deDupePass = _context.sent;
            if (deDupePass) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            if (!(_this.state.step === STEPS.accountDetails)) {
              _context.next = 10;
              break;
            }
            _this.upgradeGuest();
            _context.next = 15;
            break;
          case 10:
            _context.next = 12;
            return _this.props.postKnowYourCustomer({}, true);
          case 12:
            response = _context.sent;
            if (response.success) {
              _this.handleKYCSuccess(response);
            } else {
              _this.handleKYCFailure(response);
            }
            if (response.inprogress) {
              _this.setState({
                step: STEPS.additionalDocuments
              });
            }
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    _this.deDupeCheck = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _this$props, _this$props$formInfo, firstName, lastName, dateOfBirth, email, handleStarLogin, step, deDupeResponse;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$props = _this.props, _this$props$formInfo = _this$props.formInfo, firstName = _this$props$formInfo.firstName, lastName = _this$props$formInfo.lastName, dateOfBirth = _this$props$formInfo.dateOfBirth, email = _this$props$formInfo.email, handleStarLogin = _this$props.handleStarLogin;
            step = _this.state.step;
            if (!(step === STEPS.personalDetails)) {
              _context2.next = 8;
              break;
            }
            _context2.next = 5;
            return _this.props.postDeDupeCheckDup(firstName.value, lastName.value, dateOfBirth.value);
          case 5:
            deDupeResponse = _context2.sent;
            _context2.next = 12;
            break;
          case 8:
            if (!(step === STEPS.accountDetails)) {
              _context2.next = 12;
              break;
            }
            _context2.next = 11;
            return _this.props.postDeDupeCheckEmail(email.value);
          case 11:
            deDupeResponse = _context2.sent;
          case 12:
            if (!(deDupeResponse && !deDupeResponse.success)) {
              _context2.next = 15;
              break;
            }
            if (deDupeResponse.error_code === 'bbe3api_sic_dup_yes') {
              _this.setState({
                alertType: ALERT_TYPES.warning,
                alertTitle: ALERT_TITLES.deDupeError,
                serverResponse: getText(TEXT_KEY.REDIRECTING_TO_CLUB),
                isLoading: false
              });
              setTimeout(handleStarLogin, 4000);
            } else {
              _this.setState({
                alertType: ALERT_TYPES.error,
                alertTitle: '',
                serverResponse: deDupeResponse.error,
                isLoading: false
              });
            }
            return _context2.abrupt("return", false);
          case 15:
            return _context2.abrupt("return", true);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    _this.knowYourCustomerCheck = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var kycCheckResponse, _this$props$formInfo2, country, address, firstName, lastName, dateOfBirth, unitNumber, streetNumber, streetName, streetType, city, state, state_input, postalCode, stateValue, kycCheckInfo, addressPayload, addressComponentPayload, _iterator, _step, addressComponent, value, component, componentName, _this$props$formInfo3, documentNumber, documentType, middleName, _state, passportCountry, driverLicenceNumber, driverLicenceCardNumber, stateKey, _kycCheckResponse;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!_this.props.formInfo) {
              _context3.next = 21;
              break;
            }
            _this$props$formInfo2 = _this.props.formInfo, country = _this$props$formInfo2.country, address = _this$props$formInfo2.address, firstName = _this$props$formInfo2.firstName, lastName = _this$props$formInfo2.lastName, dateOfBirth = _this$props$formInfo2.dateOfBirth, unitNumber = _this$props$formInfo2.unitNumber, streetNumber = _this$props$formInfo2.streetNumber, streetName = _this$props$formInfo2.streetName, streetType = _this$props$formInfo2.streetType, city = _this$props$formInfo2.city, state = _this$props$formInfo2.state, state_input = _this$props$formInfo2.state_input, postalCode = _this$props$formInfo2.postalCode;
            stateValue = state.value;
            if (country.value !== 'AU' || country.value !== 'NZ') {
              stateValue = state_input.value;
            }
            kycCheckInfo = {
              issuecountry: country.value,
              dob: dateOfBirth.value,
              firstname: firstName.value,
              lastname: lastName.value
            };
            addressPayload = address.value && Object.keys(address.value).length > 0 ? address.value : {
              components: [{
                streetNumber: streetNumber.value
              }, {
                street: streetName.value
              }, {
                locality: city.value
              }, {
                province: stateValue
              }, {
                provinceCode: stateValue
              }, {
                postalCode: postalCode.value
              }, {
                country: country.value
              }, {
                countryISO: country.value
              }, {
                subBuilding: unitNumber.value
              }, {
                streetType: streetType.value
              }, {
                manual: true
              }]
            };
            addressComponentPayload = {};
            _iterator = _createForOfIteratorHelper(addressPayload.components);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                addressComponent = _step.value;
                value = Object.values(addressComponent)[0];
                component = Object.keys(addressComponent)[0];
                componentName = component.charAt(component.length - 1) === '1' ? component.slice(0, -1) : component;
                addressComponentPayload[componentName] = value;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            kycCheckInfo.addresscomponents = addressComponentPayload;
            if (_this.props.formInfo.documentType) {
              _this$props$formInfo3 = _this.props.formInfo, documentNumber = _this$props$formInfo3.documentNumber, documentType = _this$props$formInfo3.documentType, middleName = _this$props$formInfo3.middleName, _state = _this$props$formInfo3.state, passportCountry = _this$props$formInfo3.passportCountry, driverLicenceNumber = _this$props$formInfo3.driverLicenceNumber, driverLicenceCardNumber = _this$props$formInfo3.driverLicenceCardNumber;
              if (documentType.value === DOCUMENT_TYPES.DRIVER_LICENCE) {
                Object.assign(kycCheckInfo, {
                  middlename: middleName.value,
                  doctype: documentType.value,
                  licence_number: driverLicenceNumber.value,
                  licence_card_number: driverLicenceCardNumber.value
                });
                stateKey = _state.value;
                kycCheckInfo.issuestate = KycConstants.DRIVER_LICENSE_STATE_PAYLOAD[stateKey].value;
              } else if (documentType.value === DOCUMENT_TYPES.PASSPORT) {
                Object.assign(kycCheckInfo, {
                  middlename: middleName.value,
                  doctype: documentType.value,
                  docnum: documentNumber.value
                });
                kycCheckInfo.issuecountry = passportCountry.value;
              }
            }
            _context3.prev = 11;
            _context3.next = 14;
            return _this.props.postKnowYourCustomer(kycCheckInfo);
          case 14:
            _kycCheckResponse = _context3.sent;
            if (!_kycCheckResponse.success) {
              _this.setState({
                alertType: ALERT_TYPES.error,
                alertTitle: ALERT_TITLES.kycError,
                serverResponse: _kycCheckResponse && _kycCheckResponse.error,
                isLoading: false
              });
            } else {
              // Logging KYC Complete events here before the step state changes so
              // we are able to determine what step KYC completed on.
              if (_this.state.step === STEPS.accountDetails) {
                Logger.sendEvent(EVENT_TYPES.KYC_BASIC_CHECK_COMPLETED);
              } else if (_this.state.step === STEPS.additionalDocuments) {
                Logger.sendEvent(EVENT_TYPES.KYC_DOCUMENT_CHECK_COMPLETED);
              }
              _this.setState({
                step: STEPS.accountDetails,
                alertType: ALERT_TYPES.success,
                alertTitle: ALERT_TITLES.kycSuccess,
                serverResponse: _kycCheckResponse && _kycCheckResponse.msg,
                isLoading: false
              });
            }
            _context3.next = 21;
            break;
          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](11);
            _this.setState({
              isLoading: false,
              serverResponse: _context3.t0 && _context3.t0.error,
              alertType: ALERT_TYPES.error,
              alertTitle: ''
            });
          case 21:
            return _context3.abrupt("return", kycCheckResponse);
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[11, 18]]);
    }));
    _this.upgradeGuest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var upgradeUserResponse, _this$props$formInfo4, email, password, firstName, lastName, dateOfBirth, userInfo, rawResponse;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!_this.props.formInfo) {
              _context4.next = 14;
              break;
            }
            _this$props$formInfo4 = _this.props.formInfo, email = _this$props$formInfo4.email, password = _this$props$formInfo4.password, firstName = _this$props$formInfo4.firstName, lastName = _this$props$formInfo4.lastName, dateOfBirth = _this$props$formInfo4.dateOfBirth;
            userInfo = {
              firstname: firstName.value,
              lastname: lastName.value,
              dob: dateOfBirth.value
            };
            _context4.prev = 3;
            _context4.next = 6;
            return _this.props.postSsoUpgrade(_this.state.userStatus, email.value, password.value, userInfo);
          case 6:
            rawResponse = _context4.sent;
            upgradeUserResponse = rawResponse[0];
            if (!upgradeUserResponse.success) {
              _this.setState({
                alertType: ALERT_TYPES.error,
                alertTitle: '',
                isLoading: false,
                serverResponse: upgradeUserResponse && upgradeUserResponse.error
              });
            } else {
              _this.handleUpgradeSuccess(upgradeUserResponse);
            }
            _context4.next = 14;
            break;
          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](3);
            _this.setState({
              alertType: ALERT_TYPES.error,
              alertTitle: '',
              isLoading: false,
              serverResponse: _context4.t0 && _context4.t0.error
            });
          case 14:
            return _context4.abrupt("return", upgradeUserResponse);
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[3, 11]]);
    }));
    _this.handleUpgradeSuccess = function (upgradeUserResponse) {
      _this.props.addNotif({
        title: getText(TEXT_KEY.SUCCESS_NOTIFICATION_TITLE),
        message: "".concat(getText(TEXT_KEY.SUCCESS_NOTIFICATION_MESSAGE)).concat(upgradeUserResponse.casinoId, ".")
      });
      _this.props.setCasinoIdStatus(upgradeUserResponse.casinoIdStatus);
      _this.props.setPlayerId(upgradeUserResponse.playerId);
      _this.props.setCasinoId(upgradeUserResponse.casinoId);
      _this.props.setCurrentMemberLevel(upgradeUserResponse.currentMemberLevel);
      _this.props.isAccountLinked('yes');
      _this.props.propertiesRequestData();
      _this.finishUpgradeFlow();
    };
    _this.handleKYCSuccess = function () {
      var _this$props2 = _this.props,
        _this$props2$formInfo = _this$props2.formInfo,
        firstName = _this$props2$formInfo.firstName,
        lastName = _this$props2$formInfo.lastName,
        dateOfBirth = _this$props2$formInfo.dateOfBirth,
        setKYCStatus = _this$props2.setKYCStatus;
      var userInfo = {
        firstname: firstName.value,
        lastname: lastName.value,
        dob: dateOfBirth.value
      };
      setKYCStatus({
        isKYCDone: true,
        KYCResult: KycConstants.KYC_STATUS.PASS,
        KYCInfo: userInfo
      });
      _this.setState({
        step: STEPS.accountDetails
      });
    };
    _this.handleKYCFailure = function (kycCheckResponse) {
      if (kycCheckResponse.error_code === 'Kyc_fail') {
        _this.props.setKYCStatus({
          isKYCDone: true,
          KYCResult: KycConstants.KYC_STATUS.FAILED
        });
        Logger.sendEvent(EVENT_TYPES.KYC_LOCKED_OUT);
        QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.KYCLockout), RouteParamConstants.PARAM_NAVIGATE_TO, undefined), RouteParamConstants.PARAM_UPGRADE_TYPE, undefined));
      } else if (_this.state.step === STEPS.personalDetails) {
        Logger.sendEvent(EVENT_TYPES.KYC_BASIC_CHECK_FAILED);
      } else if (_this.state.step === STEPS.additionalDocuments) {
        Logger.sendEvent(EVENT_TYPES.KYC_DOCUMENT_CHECK_FAILED);
      }
    };
    _this.finishUpgradeFlow = function () {
      // Navigate to next screen if applicable, if not navigate home
      if (_this.state.navTo) {
        if (_this.state.navTo === Screens.RewardCenter) {
          rewardCenterMiddleware({
            navigation: _this.props.navigation,
            notificationContext: _this.context
          });
        } else {
          // Used on mobile to mount PurchaseFlow component in LobbyOverlay
          // the delay is there to prevent the component be displayed before the KYC modal is hidden
          setTimeout(function () {
            _this.props.initiatePurchase();
          }, 2000);
          QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Utils.getPlatform() === 'web' ? _this.state.navTo : undefined), RouteParamConstants.PARAM_NAVIGATE_TO, undefined), RouteParamConstants.PARAM_UPGRADE_TYPE, undefined));
        }
      } else {
        QueryParamsProxy.setQueryParams(_defineProperty(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined), RouteParamConstants.PARAM_UPGRADE_TYPE, undefined));
        QueryParamsProxy.navigate(_this.props.navigation, Screens.Home);
      }
    };
    return _this;
  }
  _inherits(UpgradeAccountFlow, _Component);
  return _createClass(UpgradeAccountFlow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._handleStepChange();
      var _this$props3 = this.props,
        isKYCDone = _this$props3.isKYCDone,
        KYCResult = _this$props3.KYCResult,
        KYCInfo = _this$props3.KYCInfo,
        setFormInfo = _this$props3.setFormInfo;
      if (KYCInfo && isKYCDone && KYCResult === KycConstants.KYC_STATUS.PASS) {
        this.setState({
          step: STEPS.accountDetails
        });
        setFormInfo({
          key: FormId.FIRSTNAME,
          value: KYCInfo.firstname,
          validated: true
        });
        setFormInfo({
          key: FormId.LASTNAME,
          value: KYCInfo.lastname,
          validated: true
        });
        setFormInfo({
          key: FormId.DATE_OF_BIRTH,
          value: KYCInfo.dob,
          validated: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.step !== this.state.step) {
        this._handleStepChange();
      }
      if (prevProps.formInfo.documentType && prevProps.formInfo.documentType.value !== this.props.formInfo.documentType.value) {
        this.layoutChangeHandler('toggleDocumentStateCountry', this.props.formInfo.documentType.value);
      }
      if (prevProps.formInfo.country && prevProps.formInfo.country.value !== this.props.formInfo.country.value) {
        this.handleCountryChange();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var newLayout = _objectSpread({}, this.state.layout);
      var additionalDocumentStep = STEPS.additionalDocuments;
      if (newLayout) {
        newLayout.steps[additionalDocumentStep].formInputList[5].hide = false;
        newLayout.steps[additionalDocumentStep].formInputList[6].hide = true;
        newLayout.steps[additionalDocumentStep].formInputList[7].hide = true;
        newLayout.steps[additionalDocumentStep].formInputList[8].hide = false;
        newLayout.steps[additionalDocumentStep].formInputList[9].hide = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.render({
        layout: this.state.layout,
        submitHandle: this.submitHandler,
        alertType: this.state.alertType,
        alertTitle: this.state.alertTitle,
        serverResponse: this.state.serverResponse,
        isLoading: this.state.isLoading,
        layoutChangeHandler: this.layoutChangeHandler,
        step: this.state.step,
        flowBehaviour: _defineProperty(_defineProperty(_defineProperty({}, STEPS.personalDetails, FlowBehaviours.SUBMIT), STEPS.additionalDocuments, FlowBehaviours.SUBMIT), STEPS.accountDetails, FlowBehaviours.SUBMIT)
      });
    }
  }]);
}(Component);
UpgradeAccountFlow.contextType = NotificationContext;
export { UpgradeAccountFlow as default };